// ============================================================================
// SAMPLE CATEGORY ENDPOINTS (Reference Implementation)
// ============================================================================
// Endpoint definitions for Sample Category module

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/sample-categories';

export const sampleCategoryEndpoints = {
  /** GET /api/v1/sample-categories */
  list: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/sample-categories/:id */
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/sample-categories/code/:code */
  getByCode: (code: string) => buildEndpointWithParams(`${BASE_PATH}/code/:code`, { code }),

  /** POST /api/v1/sample-categories */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /api/v1/sample-categories/:id */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** DELETE /api/v1/sample-categories/:id */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /api/v1/sample-categories/validate/code/:code */
  validateCode: (code: string) =>
    buildEndpointWithParams(`${BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default sampleCategoryEndpoints;
